<template>
<!-- 新增大类弹窗 -->
  <div class="contaier">
     <a-modal class="" :title=" type == 0 ? '新增行业大类' : '编辑行业大类'" :visible="addMasterCategoryVisible"  @cancel="closeVisible"  width="40%" @ok="submit" >
        <div>
            <a-form-model :model="masterCategory" ref="masterCategoryRef" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18 }"
                            label="所属项目"  prop="categoryName">
                            <span>{{ masterCategory.categoryName}}</span>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18 }"
                            label="行业大类名称"  prop="industryName" :rules="{
								  required: true,
								  message: '请填写行业大类名称',
								  trigger: 'change',
								}">
                                 <a-input v-model="masterCategory.industryName"></a-input>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
        </div>
     </a-modal>
  </div>
</template>

<script>
import { industryInfo, editIndustryInfo } from '@/api/surrounding'
export default {
    props: [
        // 'addMasterCategoryVisible',
        // 'type',
        // 'masterCategory'

    ],

    data() {
        return {
            addMasterCategoryVisible: false,
            masterCategory: {
                categoryName: '环境卫生检测',
                industryName: '',
                id: ''
            },
            type: ''
        }
    },
    methods: {
        init(data) {
            
            this.masterCategory.categoryName = data.categoryName
            this.type = data.type
            console.log(this.masterCategory, 'masterCategory======================')
            if(data.type == 1) {
                this.masterCategory.id = data.id
                this.masterCategory.industryName =  JSON.parse(JSON.stringify(data.industryName))
            }
            this.addMasterCategoryVisible = true
        },
        //关闭弹窗
        closeVisible() {
        
             this.$refs.masterCategoryRef.resetFields()
              this.masterCategory.industryName = ''
             this.masterCategory.categoryName = ''
            this.addMasterCategoryVisible = false
           
            // this.$emit('changeAddVisible',this.addMasterCategoryVisible)

        },
        //提交弹窗数据
        submit() {
            //提交新增事件
            if(this.type == 0) {
                this.$nextTick(() => {
                this.$refs.masterCategoryRef.validate( valid=>{
                 if(valid){
                    industryInfo({
                        // projectId: this.masterCategory.projectId,
                        projectId: 2,
                        industryName: this.masterCategory.industryName
                        }).then(res => {
                        if(res.code == 200) {
                        this.$message.success(res.msg)
                        //刷新列表
                        this.$emit('getdata')
                        // this.$refs.dataListRef.getList()
                        this.$refs.masterCategoryRef.resetFields()
                        this.masterCategory = {}
                        this.addMasterCategoryVisible = false
                        // this.$emit('changeAddVisible',this.addMasterCategoryVisible)
                        return
                        }else {
                            this.$message.error(res.msg)
                        }
                })

                    }
                    
                }
                 
                )
            })
            }
            if(this.type == 1){
                this.$refs.masterCategoryRef.validate( valid=>{
                 if(valid){
                    editIndustryInfo({
                        // projectId: this.masterCategory.projectId,
                        projectId: 2,
                        id: this.masterCategory.id,
                        industryName: this.masterCategory.industryName

                    }).then(res => {
                        if(res.code == 200) {
                        this.$message.success(res.msg)
                       
                        //刷新列表
                        this.$emit('getdata')
                        this.$refs.masterCategoryRef.resetFields()
                        this.addMasterCategoryVisible = false
                        // this.$emit('changeAddVisible',this.addMasterCategoryVisible)
                        
                        // this.masterCategory = {}
                        }else {
                            this.$message.error(res.msg)
                            // this.masterCategory = {}

                        }
                        
                        console.log(res, 'res================')
                    })
                 }
                })
            }
            //提交编辑事件

        }
    }

}
</script>

<style>

</style>